// eslint-disable-next-line import/named
import { Enum } from './tools';

const COURSE_STATUS_ALL = 0; // 全部课程状态
const COURSE_STATUS_LEARNING = 1; // 学习中的课程状态
const COURSE_STATUS_EXPIRED = 3; // 已过期课程状态

// 学习资源类型
const STUDY_RESOURCE_TYPE = new Enum()
  .add('NULL', '无', 0)
  .add('LIVE', '直播', 2)
  .add('RECORD', '录播', 3)
  .add('LECTURE', '讲义', 4)
  .add('WORK', '作业', 5)
  .add('PICTURE', '图片', 5);

// 直播资源状态
const LIVE_RESOURCE_STATUS = new Enum()
  .add('NOT_START', '未开始', 1)
  .add('LIVING', '直播中', 2)
  .add('LIVE_END', '直播结束', 3);

// 录播资源状态
const RECORD_RESOURCE_STATUS = new Enum()
  .add('DOING', '处理中', 1)
  .add('DONE_SUCCESS', '处理成功', 2)
  .add('DONE_FAIL', '处理失败', 3);

// 目录节点类型
const STUDT_NODE_TYPE = new Enum().add('CATALOG', '目录', 1).add('CONTENT', '内容', 2);

// 社群社交平台类型
const COMMUNITY_PLATFORM_TYPE = new Enum().add('QQ', 'QQ', 1).add('WECHAT', '微信', 2);

// 社群账号类型
const COMMUNITY_ACCOUNT_TYPE = new Enum().add('GROUP', '群号', 1).add('SINGLE', '个人号', 2);

// 跳转类型
const SKIPTYPE = {
  1: '链接',
  2: '产品',
  3: '自定义产品列表',
  4: '产品分类列表',
  5: '套餐',
  6: '小程序',
};
const QUALITIES = [
  // cc
  {
    1: '1080P',
    2: '720P',
    3: '高清',
    4: '清晰',
  },
  // bjy
  {
    1: '1080P',
    2: '720P',
    3: '超清',
    4: '高清',
  },
];

export {
  COURSE_STATUS_ALL,
  COURSE_STATUS_EXPIRED,
  COURSE_STATUS_LEARNING,
  STUDY_RESOURCE_TYPE,
  STUDT_NODE_TYPE,
  LIVE_RESOURCE_STATUS,
  RECORD_RESOURCE_STATUS,
  COMMUNITY_PLATFORM_TYPE,
  COMMUNITY_ACCOUNT_TYPE,
  SKIPTYPE,
  QUALITIES,
};
